import React from 'react';

import Chip from 'components/Chip';

import { colors } from 'theme/colors';

import { CONTROL_STATUS_LABEL, ControlStatus } from '../../constants';

const BACKGROUND: Record<ControlStatus, string> = {
  [ControlStatus.InPlace]: colors.ui.status.completed,
  [ControlStatus.Proposed]: colors.ui.status.inProgress,
};

const ControlStatusChip: React.FunctionComponent<{ status: ControlStatus }> = ({ status }) => (
  <Chip
    label={CONTROL_STATUS_LABEL[status]}
    size="small"
    capitalizeLabel={false}
    colors={{ background: BACKGROUND[status], foreground: colors.common.black }}
    data-status={status}
  />
);

export default ControlStatusChip;
